<template>
  <div class="relative">
    <div class="min-h-screen w-full">
      <DefaultHeader />
      <main :class="layoutWidth" class="mb-12">
        <RouterView />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { LAYOUT_WIDTH } from '@/core/constants/layout.constant';
import DefaultHeader from '@/core/components/common/DefaultHeader.vue';

const layoutWidth = ref<string>();

// Widths for the main content area. WIDE is 10% wider than DEFAULT
// (--breakpoint-xl is 80rem).
const widthClasses: Record<LAYOUT_WIDTH, string> = {
  [LAYOUT_WIDTH.FULL]: 'w-full',
  [LAYOUT_WIDTH.WIDE]: 'lg:mx-auto lg:max-w-[88rem]',
  [LAYOUT_WIDTH.DEFAULT]: 'lg:container lg:mx-auto lg:max-w-(--breakpoint-xl)',
};

const route = useRoute();
watch(
  route,
  (to) => {
    layoutWidth.value =
      widthClasses[to.meta?.width ?? LAYOUT_WIDTH.DEFAULT] ??
      widthClasses[LAYOUT_WIDTH.DEFAULT];
  },
  { flush: 'pre', immediate: true, deep: true },
);
</script>

<style lang="scss" scoped></style>
